import { Autocomplete, TextField, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import useKeyboardShortcut from 'use-keyboard-shortcut';

import Box from '@material-ui/core/Box';
// import { createTheme } from '@material-ui/core/styles';
// import './styles.css';
// import {
//   GetMaxCode,
//   EncodeLevel2Code,
//   level3CodeType,
//   columns,
// } from './HelperClass';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert2';
// import Level2CodeDialog from '../atoms/level2CodeDialog';
import {
  Button,
  Paper,
  Stack
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
// import { useAppDispatch, useAppSelector } from 'utils/hooks';
import CssBaseline from '@mui/material/CssBaseline';
import { updateAllLevels } from '../../../../store/action';
import { deleteLevel2, saveLevel2, updateLevel2 } from '../../../../utils/endPoints';
// import theme from 'theme';
import Level2CodeDialog from '../../../../components/Accounts/Account/level2CodeDialog';
import { EncodeLevel2Code, GetMaxCode, columns } from '../../../../utils/Level/utils';
import { useAppDispatch, useAppSelector } from '../../../../utils/hooks';
function Level_2() {
  const dispatch = useAppDispatch();
  // const theme2 = createTheme({
  //   palette: {
  //     mode: 'dark',
  //     primary: {
  //       main: orange[500],
  //     },
  //     typography: {
  //       h4: {
  //         fontSize: '10rem',
  //         fontFamily: 'Droid Sans',
  //       },
  //     },
  //   },
  // });
  const level_1 = useAppSelector(state => state.accountLevels.level1);
  const level_2 = useAppSelector(state => state.accountLevels.level2);
  const isMediumOrLargeScreen = useMediaQuery('(min-width: 600px)');
  const [showEntryForm, setShowEntryForm] = useState(false);
  const [code, setCode] = useState('');
  const [level1Dcode, setLevel1DCode] = useState('');
  const [level2Dcode, setLevel2DCode] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [isUpdateLevel2, setUpdateLevel2] = useState(false);
  const [levelTwoCodes, setLevelTwoCodes] = useState([]);
  const [level1, setLevel1] = useState('');
  const [l2Update, setL2Update] = useState(false);
  const [l3Update, setL3Update] = useState(false);

  useKeyboardShortcut(['F1'], () => addNewLevelCode(), {
    overrideSystem: true,
  });
  function addNewLevelCode() {
    console.log(levelTwoCodes)
    setUpdateLevel2(false);
    setDescription('');
    setShowEntryForm(true);
    setCode(EncodeLevel2Code(GetMaxCode(levelTwoCodes)));
  }

  const handleCodeLevel1 = (event, value) => {
    console.log(value)
    const code = value?.code || '';
    const description = value?.Discription || '';

    if (code !== '') {
      setCode(code);
      setLevel1({ code, description });
      setL2Update(!l2Update);
      setL3Update(!l3Update);
    } else {
      setCode('');
      setLevelTwoCodes([]);
    }
  };

  async function updateLevel2Data(event, params) {
    console.log(params);
    setUpdateLevel2(true);
    setCode(params.row.fullcode.split('-').pop());
    setDescription(params.row.Discription);
    setShowEntryForm(true);
  }

  async function checkCode(data) {
    console.log(data);
    setShowEntryForm(false);

    let codeAlreadyExist = false;
    levelTwoCodes.map(item => {
      if (item.fullcode.split('-')[1] === data.fullcode.split('-')[1]) {
        codeAlreadyExist = true;
      }
    });

    if (codeAlreadyExist === true) {
      swal.fire('Code already in used.').then(async result => {});
    } else {
      setShowEntryForm(false);
      let res = await saveLevel2(data.fullcode, data);
      console.log(res);
      if (res?.msg.endsWith('successfully')) {
        updateAllLevels(dispatch);
        setLevel1({ code: level1.code });
        toast.success(res.msg);
      } else {
        toast.error('Invalid  code!');
      }
    }
  }

  async function updateLevel3DataQuery(data) {
    setShowEntryForm(false);
    swal
      .fire({
        title: 'Are you sure to update existing code?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, update it!',
      })
      .then(async result => {
        setLoading(true);
        if (result.value) {
          setLoading(false);

          setShowEntryForm(false);
          let res = await updateLevel2(data.fullcode, data);
          console.log(res);
          if (res?.msg.endsWith('successfully')) {
            updateAllLevels(dispatch);
            setLevel1({ code: level1.code });
            toast.success(res.msg);
          } else {
            toast.error('Invalid  code!');
          }
        } else {
          setLoading(false);
        }
      });
    return;
  }
  function deleteLevel3Data(data) {
    console.log(data);
    setShowEntryForm(false);
    swal
      .fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      })
      .then(async result => {
        setLoading(true);
        if (result.value) {
          const res = await deleteLevel2(data.fullcode);
          console.log(res);
          if (res?.msg.endsWith('successfully')) {
            updateAllLevels(dispatch);
            setLevel1({ code: level1.code });
            toast.success(res.msg);
            setLoading(false);
          } else {
            setLoading(false);
            swal
              .fire(
                'Failed to delete! Level2 code cannot be deleted if child vouchers exists.',
              )
              .then(async res => {});
          }
        } else {
          setLoading(false);
        }
      });
  }

  useEffect(() => {
    if (level_2) {
      let tempArray = level_2.filter(function (el) {
        return el.fullcode?.startsWith(level1.code);
      });
      console.log(tempArray);
      setLevelTwoCodes(tempArray);

      setLevel1DCode(level1.code);
      setLevel2DCode('');
    }
  }, [level1, level_1, level_2]);

  console.log("*******",levelTwoCodes)

  return (
    <Paper>
      <CssBaseline />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          // backgroundColor: '#5CDB95',
          justifyContent: 'center',
          marginTop:'1rem',
        }}
      >
        <Typography variant="h4" component="h2" gutterBottom mt={0}>
          Chart of Acc Level '2' List
        </Typography>{' '}
        {showEntryForm ? (
          <Level2CodeDialog
            okCallback={data => {
              checkCode(data);
            }}
            cancelCallback={() => {
              setShowEntryForm(false);
            }}
            updateCallback={data => {
              updateLevel3DataQuery(data);
            }}
            deleteCallback={data => {
              deleteLevel3Data(data);
            }}
            l1code={level1Dcode}
            newCode={code}
            defaultDescription={description}
            visible={showEntryForm}
            updateLevel2={isUpdateLevel2}
          ></Level2CodeDialog>
        ) : (
          <></>
        )}
        <Stack direction={isMediumOrLargeScreen ? 'row' : 'column'} spacing={2}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Box sx={{ minWidth: '90%' }}>
              <Autocomplete
                onChange={handleCodeLevel1}
                disablePortal
                id="combo-box-code"
                getOptionLabel={option =>
                  option.code + '\t' + option.Discription
                } //<--
                options={level_1}
                renderInput={params => (
                  <TextField
                    {...params}
                    style={{ width: '300px' }}
                    label="Level One Code"
                  />
                )}
              />
            </Box>
          </div>
          <Button
            variant="contained"
            color="primary"
            onClick={addNewLevelCode}
            disabled={code === '' ? true : false}
          >
            Add
          </Button>
        </Stack>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '90%',
            height: '75vh',
            // backgroundColor: '#EDF5E1',
            marginTop: '1rem',
          }}
        >
          <DataGrid
            hideFooter
            headerHeight={20}
            rowHeight={25}
            onCellDoubleClick={(params, event) => {
              updateLevel2Data(event, params);
            }}
            style={{ width: '100%' }}
            // onCellClick={CellonClick}
            rows={levelTwoCodes.map((item, index) => {
              return { id: index + 1, ...item };
            })}
            columns={columns}
            pageSize={25}
            disableColumnMenu
          />
        </div>
      </div>
      <ToastContainer
        position="bottom-center"
        autoClose={2000}
        hideProgressBar={true}
        closeOnClick={true}
        progress={undefined}
      />
    </Paper>
  );
}

export default Level_2;
